export class Question {
    constructor(id, name, description, status, position, width, forced, options, type, sections) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.status = status;
        this.position = position;
        this.width = width;
        this.forced = forced;
        this.options = options;
        this.type = type;
        this.sections = sections;
    }
}
